
import $ from 'jquery';

/**
 * Fire DY custom event PDP_DELAYED_ADD_TO_CART when product added to cart via pdp (5s delay)
 */
$( document ).on( 'click', '.tpl_article_detail .en_mdl_article_detail__button', function( e ) {
	if ( 'undefined' !== typeof DY ) {
		let delays = [5000, 10000, 15000];
		delays.forEach( function( delay, index ) {
			setTimeout( function() {
				DY.API( 'event',
					{
						name: 'PDP_DELAY_' + ( delay / 1000 ) + 'S_ADD_TO_CART',
					},
				);
			}, delay );
		} )
	}
} );

/**
 * Save custom object of removed items from cart (max. 10 items)
 */
$( document ).on( 'click', '.mdl_article_item__remove', function( e ) {
	const removeTrigger = $( this );
	const marketartikelid = removeTrigger.attr( 'data-eec-id' );

	if ( 'undefined' !== typeof DY ) {
		var addedItemsFromRelOnPDPToCart = EN.Cookies.get( 'addedItemsFromRelOnPDPToCart' ) ? JSON.parse( EN.Cookies.get( 'addedItemsFromRelOnPDPToCart' ) ) : [];

		if( addedItemsFromRelOnPDPToCart && addedItemsFromRelOnPDPToCart.includes( marketartikelid ) ) {
			const index = addedItemsFromRelOnPDPToCart.indexOf( marketartikelid );
			addedItemsFromRelOnPDPToCart.splice( index,1 );
			EN.Cookies.set( 'addedItemsFromSimOnPDPToCart', JSON.stringify( addedItemsFromRelOnPDPToCart ) );
		}
	}
} );

/**
 * Fire DY custom events PDP_DELAY_%S_REMOVE_ADDTOCART_MS when added to cart message is closed (5s, 10s, 15s delay)
 */
$( document ).on( 'click', '.mdl_addedtocart__close', function( e ) {
	if ( 'undefined' !== typeof DY ) {
		let delays = [5000, 10000, 15000];
		delays.forEach( function( delay, index ) {
			setTimeout( function() {
				DY.API( 'event',
					{
						name: 'PDP_DELAY_' + ( delay / 1000 ) + 'S_REMOVE_ADDTOCART_MS',
					},
				);
			}, delay );
		} )
	}
} );

$( document ).on( 'click', '#dyrel .mdl_productcarousel_item__image-cnt-inner, #dyrel .mdl_productcarousel_item__content, #dyrel .mdl_productcarousel_item__cta', function() {
	$( this ).attr( 'href', $( this ).attr( 'href' ) + '?related=1' );
} );


$( document ).on( 'added_to_cart.sl', function( e,  marketartikelid, aid ) {
	let watchedItemsFromRelOnPDP = EN.Cookies.get( 'watchedItemsFromRelOnPDP' ) ? JSON.parse( EN.Cookies.get( 'watchedItemsFromRelOnPDP' ) ) : [];
	let addedItemsFromRelOnPDPToCart = EN.Cookies.get( 'addedItemsFromRelOnPDPToCart' ) ? JSON.parse( EN.Cookies.get( 'addedItemsFromRelOnPDPToCart' ) ) : [];

	if( watchedItemsFromRelOnPDP.includes( marketartikelid ) && !addedItemsFromRelOnPDPToCart.includes( marketartikelid ) ) {
		addedItemsFromRelOnPDPToCart.unshift( marketartikelid );
		EN.Cookies.set( 'addedItemsFromRelOnPDPToCart', JSON.stringify( addedItemsFromRelOnPDPToCart ) );

		if ( 'undefined' !== typeof DY ) {
			DY.API( 'event',
				{
					name: 'ADD_ITEM_REL_ON_PDP_TO_CART',
				},
			);
		}
	}
} );

/**
 * Save last added to cart product DY object to cookie
 */
$( document ).on( 'added_to_cart.sl', function( e, marketartikelid, aid ) {
	if ( 'undefined' !== typeof DY ) {
		DY.itemsData.forEach( function( item, index ) {
			if ( item.sku === aid ) {
				localStorage.setItem( 'lastItemAddedToCart', JSON.stringify( {
					'sku': item.sku,
					'gender': item.gender
				} ) );
			}
		} );
	}
} );

$( document ).ready( function() {
	const lastItemAddedToCartCookie = EN.Cookies.get( 'lastItemAddedToCart' ) ? JSON.parse( EN.Cookies.get( 'lastItemAddedToCart' ) ) : '';
	if ( lastItemAddedToCartCookie && 'sku' in lastItemAddedToCartCookie && 'gender' in lastItemAddedToCartCookie && ! localStorage.getItem( 'lastItemAddedToCartCookie' ) ) {
		localStorage.setItem( 'lastItemAddedToCart', JSON.stringify( {
			'sku': lastItemAddedToCartCookie.sku,
			'gender': lastItemAddedToCartCookie.gender
		} ) );
	}
	EN.Cookies.remove( 'lastItemAddedToCart' );

	document.addEventListener( 'click', ( ev ) => {

		// We cannot track events without DY.
		if ( 'undefined' === typeof DY ) {
			return;
		}

		// KOC-11590: Track clicks on products because of sorting of products
		if ( ev.target.closest( '.en_mdl_products .en_mdl_product' ) && !ev.target.closest( '.en_mdl_product__wishlist-button' ) ) {
			DY.API( 'event',
				{
					name: 'PLP_PRODUCT_CLICK',
				}
			);
		}

		if ( ev.target.matches( '.mdl_carouselcontrols__control-trigger' ) && ev.target.closest( '.topseller-carousel' ) ) {
		  DY.API( 'event',
				{
			  name: 'TOPSELLER_CAROUSEL_CONTROLS_CLICK',
				}
		  );
		}

		// KOC-10539: Track more eye-catching colors in banner.
		if ( ev.target.closest( '.mdl_smallbanner .en_voucher_box__copy' ) ) {
			DY.API( 'event',
				{
					name: 'GLOBAlBANNER_VOUCHER_COPIED',
				}
			);
		} else if ( ev.target.closest( '.mdl_smallbanner' ) ) {
			DY.API( 'event',
				{
					name: 'GLOBAlBANNER_CLICK',
				}
			);
		}

		// KOC-11169: MDL LINKTAGS with different Headline.
		// Deprecated because ab test finished
		if ( ev.target.closest( '.mdl_linktags .mdl_linktags_entry' ) ) {
			const linkEl = ev.target.closest( '.mdl_linktags .mdl_linktags_entry' );
			DY.API( 'event',
				{
					name: 'PDP_LINKTAGS_LINK_CLICK',
					properties: {
						text: String( linkEl.innerText ).trim(),
						href: linkEl.href,
					},
				}
			);
		}
	} );
} )

$( function() {
	const url = new URL( window.location );
	if( url.searchParams.get( 'related' ) == 1 ) {
		let watchedItemsFromRelOnPDP = EN.Cookies.get( 'watchedItemsFromRelOnPDP' ) ? JSON.parse( EN.Cookies.get( 'watchedItemsFromRelOnPDP' ) ) : [];

		let newWatchedItem = $( '#articletobasketform input[name="marketartikelid"]' );

		if( newWatchedItem.length && !watchedItemsFromRelOnPDP.includes( newWatchedItem.val() ) ) {
			watchedItemsFromRelOnPDP.unshift( newWatchedItem.val() );
			EN.Cookies.set( 'watchedItemsFromRelOnPDP', JSON.stringify( watchedItemsFromRelOnPDP ) );
		}

		if ( 'undefined' !== typeof DY ) {
			DY.API( 'event',
				{
					name: 'PDP_RELATED_REFERER',
				},
			);
		}
		url.searchParams.delete( 'related' );
		window.history.replaceState( {}, '', url );
	}
} );

window._eightselect_shop_plugin = window._eightselect_shop_plugin || {};
window._eightselect_shop_plugin.testgroup = '8Related';
